const mirrorState = (cantonInputElement, cantonGroupElement) =>
  cantonGroupElement.classList.toggle("active", cantonInputElement.checked);
const wrapperElement = document.getElementById("search");

export default function setup() {
  const inputElements = wrapperElement?.querySelector(".cottage_filter_regions");
  if (!inputElements) return;

  for (const cantonGroupElement of wrapperElement.querySelectorAll("svg .canton")) {
    const canton = cantonGroupElement.dataset.canton;
    const cantonInputElement = inputElements.querySelector(`input[value='${canton}']`);
    cantonGroupElement.addEventListener("click", () => {
      cantonInputElement.checked = !cantonInputElement.checked;
      mirrorState(cantonInputElement, cantonGroupElement);
    });
    mirrorState(cantonInputElement, cantonGroupElement);
  }
}
